"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tavernola-bergamasca": {
    "7331c6e6": [{
      "hkey": "43159e7b",
      "slug": "tavernola-bergamasca",
      "name": "Tavernola Bergamasca",
      "primary": true,
      "skipSearch": false
    }],
    "bianica": [{
      "hkey": "43159e7b",
      "slug": "tavernola-bergamasca",
      "name": "Tavernola Bergamasca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7e224a2e": [{
      "hkey": "43159e7b",
      "slug": "tavernola-bergamasca",
      "name": "Tavernola Bergamasca",
      "primary": true,
      "skipSearch": false
    }],
    "cambianica": [{
      "hkey": "43159e7b",
      "slug": "tavernola-bergamasca",
      "name": "Tavernola Bergamasca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;